import React, { useState } from "react";
import { BreadCrumbs } from "../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../shared/topBar/TopBar";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Tenant } from "./TenantTab";
import { Roles } from "./RolesTab";
import { Services } from "./ServicesTab";
import { Users } from "./Users";
import { Menus } from "./Menus";
import { Themes } from "./Themes";
import { ThemeExcelAddIn } from "./ThemeExcelAddIn";
import { UrlPath } from "../../config/routeConfig";
import { useLocation } from "react-router-dom";
import { RoleToUser } from "./RoleToUser";
import { MenuToRole } from "./MenuToRole";
import { SubMenuToRole } from "./SubMenuToRole";
import { SBAComboBox, SBADropDown } from "../UiComponents/SBADropDown";
import { ToastContainer, toast } from 'react-toastify';
import { useEffect } from "react";
import { PageLevelToUser } from "./PageToUser";
import { PortfolioToUser } from "./PortfolioToUser";
import { TaxEntityToUser } from "./TaxEntityToUser";
import { ContactToUser } from "./ContactToUser";
import { Error403 } from "../shared/ErrorPage/ErrorPage";
import { Unauthorized } from "../shared/ErrorPage/ErrorPage";
import { getUserPageAccess } from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios";

export const Permissions = () => {
  const options = [
    { value: "0", label: "Tenant" },
    { value: "1", label: "Roles" },
    { value: "2", label: "Users" },
    { value: "3", label: "Services" },
    { value: "4", label: "Menus" },
    { value: "5", label: "Report Theme Setup" },
  ];
  const assignmentOptions = [
      { value: "0", label: "Role To User" },
      { value: "1", label: "Menu To Role" },
      { value: "2", label: "Sub Menu To Role" },
      { value: "3", label: "Page Level To User" },
      { value: "4", label: "Portfolio To User" },
      { value: "5", label: "Account To User" },
      { value: "6", label: "Contact To User" },
  ];
  const [selectedTabOption, setSelectedTabOption] = useState(options[0]);
  const [selectedAssignmentTabOption, setSelectedAssignmentTabOption] = useState(assignmentOptions[0]);
  const [viewAccess, setViewAccess] = useState(true);

  const getAdminAccessStatus = async() => {
    await sbaAxios({ url: `${getUserPageAccess}?keyName=AdminPermissionAccess` }).then(res => {
        setViewAccess(res);
    }).catch(er => {
        setViewAccess(false);
    });
  };

  useEffect(()=> {
    getAdminAccessStatus();
  },[]);

useEffect(()=>{
  document.title="Admin";
},[])

  let gridComponent;
  let AssignmentGridComponent;
  const locationData = useLocation();
  const Level = [
    {
      BreadCrumb: "Admin >",
          Routes: `${UrlPath.Admin}`,
    },
      { BreadCrumb: "Permissions", Routes: `${UrlPath.Admin}` },
  ];
  const handleTabChange = (eventKey) => {
    setSelectedTabOption(eventKey);
  };

  const previouslyActiveTab =
    locationData.state === null
      ? "Configuration"
      : locationData.state.ActiveTab;



  switch (selectedTabOption.value) {
    case "0":
      gridComponent = <Tenant />; // Tenant component here
      break;
    case "1":
      gridComponent = <Roles />; // Roles component here
      break;
    case "2":
      gridComponent = <Users />; // Users component here
      break;
    case "3":
      gridComponent = <Services />; // Services component here
      break;
    case "4":
      gridComponent = <Menus />; // Menus component here
      break;
    case "5":
    gridComponent = <ThemeExcelAddIn />; // ThemeExcelAddIn component here
    break;
    default:
      gridComponent = null;
  }
  switch (selectedAssignmentTabOption.value) {
    case "0":
      AssignmentGridComponent = <RoleToUser />; // Role component here
      break;
    case "1":
      AssignmentGridComponent = <MenuToRole />; // Menu component here
      break;
    case "2":
      AssignmentGridComponent = <SubMenuToRole />; // SubMenu component here
      break;
    case "3":
      AssignmentGridComponent = <PageLevelToUser />; // SubMenu component here
      break;
    case "4":
      AssignmentGridComponent = <PortfolioToUser />; 
      break;
    case "5":
      AssignmentGridComponent = <TaxEntityToUser />;
      break;
    case "6":
      AssignmentGridComponent = <ContactToUser />;
      break;
    default:
      AssignmentGridComponent = null;
  }

  const Configuration=() =>{
    useEffect(()=>{
      toast.dismiss();
    },[])

      return (
        <div className="p-3 bg-white life-science rounded">
        <div className="row m-0" style={{ margintop: "-5px" }}>
          <div className="col-lg-12 px-0">
            <div className="col-md-4">
              <label
                htmlFor="select-fund"
                className="mb-1 ms-2 fw-semibold fs-12"
              >
                Select option
              </label>
              <div>
                <SBADropDown data={options} textField={'label'} valueField={'value'} value={selectedTabOption}
                  onChange={(event) => {
                    setSelectedTabOption(event.value)
                  }
                  } />
              </div>
            </div>
            {gridComponent}
          </div>
        </div>
      </div>
      )
  };
  const Assignment=()=>{
    useEffect(()=>{
      toast.dismiss();
    },[])
    return <div className="p-3 bg-white life-science rounded">
    <div className="row m-0" style={{ margintop: "-5px" }}>
      <div className="col-lg-12 px-0">
        <div className="col-md-4">
          <label
            htmlFor="select-fund"
            className="mb-1 ms-2 fw-semibold fs-12"
          >
            Select option
          </label>
          <div>
            <SBADropDown data={assignmentOptions} textField={'label'} valueField={'value'} value={selectedAssignmentTabOption}
              onChange={(event) => {
                setSelectedAssignmentTabOption(event.value)
              }
              } />
          </div>
        </div>
        {AssignmentGridComponent}
      </div>
    </div>
  </div>
  };

  if (!viewAccess) {
    return (
    <div className='mainContentData'> 
<Unauthorized></Unauthorized> 
</div>
    )
  }
  else{
    return (
      <div >
        <TopBar label={"Permissions"} />
        <div  className="mainContentData">
          <BreadCrumbs Levels={Level} />
          <div className="p-4">
            <Tabs
              defaultActiveKey={previouslyActiveTab}
              id="uncontrolled-tab-example"
              className="ms-3"
              onSelect={handleTabChange}
            >
              <Tab eventKey="Configuration" title="Configuration">
               <Configuration/>
              </Tab>
              <Tab eventKey="Assignment" title="Assignment" >
                <Assignment/>
              </Tab>
            </Tabs>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
};
